import { render } from "./CustomerCreateBasic.vue?vue&type=template&id=8bd6ffb0&scoped=true"
import script from "./CustomerCreateBasic.vue?vue&type=script&lang=js"
export * from "./CustomerCreateBasic.vue?vue&type=script&lang=js"

import "./CustomerCreateBasic.vue?vue&type=style&index=0&id=8bd6ffb0&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd6ffb0"]])

export default __exports__